import type { SelectedStatement } from '@/pages/CompanyReport/redux/interface';
import RiskReward from '../RiskReward';
import type { CompanySubSection } from '@/pages/CompanyReport/hooks/useReportUrlHandler';
import {
  RiskProps,
  SummaryRiskStatus,
} from '@/pages/CompanyReport/components/SummaryCompare';

interface RiskSummaryListProps {
  summaryRiskStatus: SummaryRiskStatus;
  firstFourFailingRisks: (SelectedStatement & RiskProps)[];
  totalFailingRisks: number;
  tickerSymbol: string;
}

const RiskSummaryList = ({
  summaryRiskStatus,
  firstFourFailingRisks,
  totalFailingRisks,
  tickerSymbol,
}: RiskSummaryListProps) => {
  const totalRisksNotShownInSummary =
    totalFailingRisks - firstFourFailingRisks.length;
  switch (summaryRiskStatus) {
    case SummaryRiskStatus.HasPassedAllRisks:
      return <p>{`${tickerSymbol} passed our risk checks.`}</p>;
    case SummaryRiskStatus.HasNotFailedAnyRisk:
      return (
        <p>{`No risks detected for ${tickerSymbol} from our risk checks.`}</p>
      );
    case SummaryRiskStatus.InsufficientData:
      return <p>Insufficient data to perform risk analysis</p>;
    default: {
      return (
        <>
          {firstFourFailingRisks.map((risk, i) => {
            return (
              <RiskReward
                name={risk.name}
                key={i}
                index={i}
                severity={risk.severity}
                description={risk.description}
                hash={risk.hash?.replace('#', '') as CompanySubSection}
              />
            );
          })}
          {totalFailingRisks > 4 ? (
            <p>
              {`+ ${totalRisksNotShownInSummary} more ${
                totalRisksNotShownInSummary > 1 ? 'risks' : 'risk'
              }`}
            </p>
          ) : (
            <br />
          )}
        </>
      );
    }
  }
};

export default RiskSummaryList;
